import http from "@/services/http";
import {PUBLIC_RECOMMENDATION_URL, RECOMMENDATION_URL} from "@/services/endpoints";

export function  getRecommendationList(params) {
  return http.request({
    url:PUBLIC_RECOMMENDATION_URL,
    method:'get',
    params
  })
}
export function  fetchRecommendation(id) {
  return http.request({
    url:PUBLIC_RECOMMENDATION_URL+`/${id}`,
    method:'get',
  })
}
